import { render, staticRenderFns } from "./daochuBanKuai.vue?vue&type=template&id=523a63de&scoped=true"
import script from "./daochuBanKuai.vue?vue&type=script&lang=js"
export * from "./daochuBanKuai.vue?vue&type=script&lang=js"
import style0 from "./daochuBanKuai.vue?vue&type=style&index=0&id=523a63de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523a63de",
  null
  
)

export default component.exports